/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M6.5303 14.4697a.75.75 0 0 1 0 1.0606L5.0607 17l1.4696 1.4697a.75.75 0 0 1-1.0607 1.0606L2.9394 17l2.5304-2.5303a.75.75 0 0 1 1.0606 0ZM8.4697 18.4697a.75.75 0 0 0 1.0607 1.0606L12.0606 17l-2.5304-2.5303a.75.75 0 0 0-1.0606 1.0606L9.9393 17l-1.4696 1.4697Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 0C.4477 0 0 .4477 0 1v7c0 .5523.4477 1 1 1s1-.4477 1-1v-.25h7V8c0 .5523.4477 1 1 1s1-.4477 1-1v-.25h1c.6904 0 1.25.5596 1.25 1.25v1.25H2.75C1.2312 10.25 0 11.4812 0 13v8c0 1.5188 1.2312 2.75 2.75 2.75h10.5c1.3929 0 2.5812-.8763 3.0436-2.1077C17.3574 22.3425 18.6311 22.75 20 22.75h2V23c0 .5523.4477 1 1 1s1-.4477 1-1v-7c0-.5523-.4477-1-1-1s-1 .4477-1 1v.25h-1c-.6904 0-1.25-.5596-1.25-1.25V8c0-3.728-3.0221-6.75-6.75-6.75h-2V1c0-.5523-.4477-1-1-1S9 .4477 9 1v.25H2V1c0-.5523-.4477-1-1-1Zm13.9997 20.5343C13.9125 19.3361 13.25 17.7454 13.25 16v-4.25H2.75c-.6904 0-1.25.5596-1.25 1.25v8c0 .6904.5596 1.25 1.25 1.25h10.5c.955 0 1.7314-.765 1.7497-1.7157ZM14.75 16c0 2.8995 2.3505 5.25 5.25 5.25h2v-3.5h-1c-1.5188 0-2.75-1.2312-2.75-2.75V8c0-2.8995-2.3505-5.25-5.25-5.25h-2v3.5h1c1.5188 0 2.75 1.2312 2.75 2.75v7ZM9 2.75H2v3.5h7v-3.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuPipelines'
);
